import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { PolicyEmail } from "./PolicyPage";

function Privacy() {
  const sections = [
    {
      title: "Scope",
      content: (
        <p>
          This policy explains how tugglefield collects, uses, discloses, and
          protects personal information when you visit this website, place an
          order, contact us, or otherwise interact with our services.
        </p>
      ),
    },
    {
      title: "Information we collect",
      content: (
        <>
          <p>Depending on how you use the site, we may collect:</p>
          <ul>
            <li>contact details, including your name, email, phone number, and delivery address;</li>
            <li>order, billing, transaction, return, and customer-support records;</li>
            <li>account or preference information that you choose to provide;</li>
            <li>device, browser, IP address, approximate location, referring page, and site-usage data; and</li>
            <li>communications, reviews, survey responses, or other content you submit.</li>
          </ul>
          <p>
            We may receive some of this information from payment processors,
            carriers, fraud-prevention providers, analytics providers, or other
            service providers involved in fulfilling your request.
          </p>
        </>
      ),
    },
    {
      title: "How we use information",
      content: (
        <p>
          We use information to operate the site; process, deliver, and support
          orders; communicate with you; maintain carts and preferences; prevent
          fraud and abuse; improve products and site performance; comply with
          law; enforce our terms; and send marketing only where permitted or
          requested.
        </p>
      ),
    },
    {
      title: "Legal bases where applicable",
      content: (
        <p>
          Where data-protection law requires a legal basis, we process personal
          information as needed to perform a contract, comply with legal duties,
          pursue legitimate interests that are not overridden by your rights,
          protect vital or legal interests, or act with your consent. You may
          withdraw consent for future processing at any time.
        </p>
      ),
    },
    {
      title: "Payments",
      content: (
        <p>
          Payment details are submitted to the payment provider made available
          at checkout. tugglefield does not intentionally store complete payment
          card numbers or card security codes in its website records. Payment
          providers process information under their own privacy terms.
        </p>
      ),
    },
    {
      title: "When information is disclosed",
      content: (
        <>
          <p>
            We disclose information only as reasonably necessary to providers
            supporting hosting, payments, order fulfillment, delivery,
            communications, analytics, security, professional advice, and
            customer service. We may also disclose information:
          </p>
          <ul>
            <li>when required by law, court order, or valid legal process;</li>
            <li>to protect customers, tugglefield, or others from fraud, harm, or misuse;</li>
            <li>in connection with a merger, financing, reorganization, or sale of business assets; or</li>
            <li>at your direction or with your consent.</li>
          </ul>
          <p>We do not sell personal information for monetary payment.</p>
        </>
      ),
    },
    {
      title: "Cookies and local storage",
      content: (
        <p>
          The site uses browser storage for essential functions such as keeping
          items in your cart. Other technologies may be used for preferences,
          measurement, or marketing when enabled. See our <Link to="/cookies">Cookie Policy</Link> for
          details and choices.
        </p>
      ),
    },
    {
      title: "Retention",
      content: (
        <p>
          We keep personal information only for as long as reasonably necessary
          for the purposes described here, including fulfillment, customer
          service, fraud prevention, tax and accounting records, disputes, and
          legal obligations. Retention periods vary by record type and applicable law.
        </p>
      ),
    },
    {
      title: "Security",
      content: (
        <p>
          We use reasonable administrative, technical, and organizational
          safeguards designed to protect personal information. No internet
          transmission or storage system is completely secure, so absolute
          security cannot be guaranteed.
        </p>
      ),
    },
    {
      title: "Your privacy rights",
      content: (
        <p>
          Depending on where you live, you may have rights to access, correct,
          delete, restrict, object to processing of, or receive a portable copy
          of personal information. You may also withdraw consent or opt out of
          certain marketing or targeted advertising. See <Link to="/privacy-choices">Your Privacy Choices</Link> or
          email us. We may verify your identity before completing a request.
        </p>
      ),
    },
    {
      title: "Children",
      content: (
        <p>
          The site is intended for a general audience and is not directed to
          children under 13. We do not knowingly collect personal information
          from children under 13. A parent or guardian who believes a child has
          provided information may contact us to request deletion.
        </p>
      ),
    },
    {
      title: "International processing",
      content: (
        <p>
          Providers may process information in countries with different privacy
          laws from your own. Where required, we use appropriate contractual or
          other safeguards for cross-border transfers.
        </p>
      ),
    },
    {
      title: "External services",
      content: (
        <p>
          Links or embedded services operated by others are governed by their
          own privacy practices. This policy does not control third-party
          websites or services that tugglefield does not operate.
        </p>
      ),
    },
    {
      title: "Changes and contact",
      content: (
        <p>
          We may update this policy to reflect changes in law, technology, or
          our services. The date above identifies the latest version. For
          privacy questions or requests, email <PolicyEmail />.
        </p>
      ),
    },
  ];

  return (
    <PolicyPage
      title="Privacy Policy"
      intro={<p>Your privacy matters to tugglefield. This policy applies to this store and the customer interactions described below.</p>}
      sections={sections}
    />
  );
}

export default Privacy;
